import React from "react";

import SongIcon from "../icons/song";

import DeezerIsologo from "../icons/streaming-isologos/deezer";
import PandoraIsologo from "../icons/streaming-isologos/pandora";
import TidalIsologo from "../icons/streaming-isologos/tidal";
import SpotifyIsologo from "../icons/streaming-isologos/spotify";
import NapsterIsologo from "../icons/streaming-isologos/napster";
import AppleMusicIsologo from "../icons/streaming-isologos/apple";
import AmazonMusicIsologo from "../icons/streaming-isologos/amazon";
import SoundcloudIsologo from "../icons/streaming-isologos/soundcloud";

import { SocialNetwork } from "@common/types/data/social-network";

import { TracLinkPlatform } from "@services/tracpage/types/trac-link-platform";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faSnapchat,
  faTiktok,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

export const getSocialIcon = (
  iconName: SocialNetwork["network"] | TracLinkPlatform
) => {
  switch (iconName) {
    case "facebook":
      return <FontAwesomeIcon icon={faFacebook} />;
    case "twitter":
      return <FontAwesomeIcon icon={faTwitter} />;
    case "instagram":
      return <FontAwesomeIcon icon={faInstagram} />;
    case "linkedin":
      return <FontAwesomeIcon icon={faLinkedin} />;
    case "youtube":
      return <FontAwesomeIcon icon={faYoutube} />;
    case "tiktok":
      return <FontAwesomeIcon icon={faTiktok} />;
    case "snapchat":
      return <FontAwesomeIcon icon={faSnapchat} />;
    case "amazonMusic":
    case "amazon":
      return <AmazonMusicIsologo />;
    case "appleMusic":
    case "apple":
      return <AppleMusicIsologo />;
    case "napster":
      return <NapsterIsologo />;
    case "spotify":
      return <SpotifyIsologo />;
    case "tidal":
      return <TidalIsologo />;
    case "soundcloud":
      return <SoundcloudIsologo />;
    case "deezer":
      return <DeezerIsologo />;
    case "pandora":
      return <PandoraIsologo />;
    default:
      return <SongIcon />;
  }
};
